<template>
  <v-dialog
    :value="value" persistent max-width="360px"
    @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="text-h5">
        {{ title || labels.areYouSure }}
      </v-card-title>
      <v-card-text>{{ text || labels.text }}</v-card-text>
      <v-card-actions>
        <BaseSecondaryBtn
          :is-block="false" :title="declineText || labels.decline" style="width:49%"
          @click="decline" />
        <v-spacer />
        <BaseSecondaryBtn
          :is-block="false" :title="acceptText || labels.accept" style="width:49%"
          @click="accept" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    value: { type: Boolean, default () { return false } },
    title: { type: String, default () { return null } },
    text: { type: String, default () { return null } },
    acceptText: { type: String, default () { return null } },
    declineText: { type: String, default () { return null } },
  },
  computed: {
    labels () {
      return this.getLabels(this.$store.getters.getLanguage).dialog
    },
  },
  methods: {
    accept () {
      this.$emit('dialog-accepted')
    },
    decline () {
      this.$emit('dialog-declined')
    },
  },
}
</script>
